import React, { useState, Component, useMemo, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DataTable from "../_Components/DataTable";

import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import { green } from "@mui/material/colors";
// import ApiPublicPromoCodeService from "../../../core/api/api.publicPromoCode";
let showPrice = Intl.NumberFormat("en-US");
function DataGridUsedPromoCodeByUser(props) {
  let location = useLocation();
  const [checkBoxList, setCheckBoxList] = useState([]);

  useEffect(() => {
    props.setCheckBoxList2(checkBoxList);
  }, [checkBoxList]);
  const handleChangeIsDefault = (name) => (event) => {
    callApiService(name, 1);
  };
  function showDetail(prp) {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "ندارد";
  }
  async function callApiService(item, flag) {
    // console.log("item",item)
    // const response = await ApiPublicPromoCodeService.removePublicPromoCode({
    //     id: item.allPublicPromoCodeViewModel.id,
    //     Status: !item.allPublicPromoCodeViewModel.isDeleted
    //     });
    // if (response.succeeded == true)
    //     (document.getElementById('submitButton')).click();
    // SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const handleSelect = (id, node) => {
    if (node.agentCommisionPrice == 0 || node.agentCommisionPrice == null) {
      SwalMessage({
        title: "لطفا مواردی که مبلغ کمیسیون دارند را انتخاب کنید ",
        iSsuccess: false,
      });
    } else {
      const data = {
        id: node.id,
        promoCategoryCommisionId: node.promoCategoryCommisionId,
        promoCategoryId: node.promoCategoryId,
      };
      checkBoxList.some((item) => data.id == item.id)
        ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item.id != data.id))
        : !_.isEmpty(checkBoxList)
          ? checkBoxList.some(
              (item) =>
                data.promoCategoryCommisionId == item.promoCategoryCommisionId &&
                data.promoCategoryId == item.promoCategoryId,
            )
            ? setCheckBoxList((checkBoxList) => [...checkBoxList, data])
            : SwalMessage({ title: "جهت انتخاب گروهی ،گروه تخفیف و کمیسیون باید یکسان باشند", iSsuccess: false })
          : setCheckBoxList((checkBoxList) => [...checkBoxList, data]);
    }
  };
  const columns = useMemo(() => [
    {
      accessor: "#",
      Header: "انتخاب",
      minWidth: 15,
      Cell: ({ row }) =>
        row.original.agentCommisionPrice != 0 && row.original.agentCommissionIsSettled == true ? (
          <>
            <div
              onClick={() => handleSelect(row.original.id, row.original)}
              style={{
                pointerevents: "none",
                opacity: 0.7,
              }}
            >
              {" "}
              <input
                type="checkbox"
                className="ml-6 pl-6 my-1 "
                checked={!_.isEmpty(checkBoxList) ? checkBoxList.some((item) => row.original.id == item.id) : false}
              />
            </div>
          </>
        ) : (
          ""
        ),
    },
    {
      accessor: "agentName",
      Header: "نماینده فروش",
      minWidth: 150,
    },
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "userPhoneNumber",
      Header: "شماره موبایل",
      minWidth: "100px",
      Cell: ({ row }) => <div className="ltr">{row.original.userPhoneNumber}</div>,
    },
    {
      accessor: "promoCode",
      Header: "کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "amusmentServiceName",
      Header: "نام سرویس",
      minWidth: "100px",
    },
    {
      accessor: "amusmentServicePlace",
      Header: "مکان",
      minWidth: "30px",
      Cell: ({ row }) => (
        <div className="ltr">{row.original.amusmentServicePlace != null ? row.original.amusmentServicePlace : "-"}</div>
      ),
    },
    {
      accessor: "createdTimeBasketItem",
      Header: "تاریخ خرید",
      minWidth: "100px",
    },
    {
      accessor: "checkInDate",
      Header: "تاریخ استفاده",
      minWidth: "100px",
    },
    {
      accessor: "originalPrice",
      Header: "قیمت اصلی",
      minWidth: "100px",
      Cell: ({ row }) => <>{showPrice.format(row.original.originalPrice)}</>,
    },
    {
      accessor: "salePrice",
      Header: "قیمت فروش سایت",
      minWidth: "130px",
      Cell: ({ row }) => <>{showPrice.format(row.original.salePrice)}</>,
    },
    {
      accessor: "promoCodeDiscountPrice",
      Header: "مبلغ تخفیف",
      minWidth: "100px",
      Cell: ({ row }) => <>{showPrice.format(row.original.promoCodeDiscountPrice)}</>,
    },
    {
      accessor: "price",
      Header: "قیمت نهایی کاربر",
      minWidth: "130px",
      Cell: ({ row }) => <>{showPrice.format(row.original.price)}</>,
    },

    {
      accessor: "agentCommisionPrice",
      Header: "کمیسیون",
      minWidth: "100px",
      Cell: ({ row }) => (
        <>
          {row.original.agentCommisionPrice == 0 || row.original.agentCommisionPrice == null
            ? "درانتظار"
            : showPrice.format(row.original.agentCommisionPrice)}
        </>
      ),
    },
    {
      accessor: "promoCodePublicationTypeS",
      Header: "نوع کدتخفیف",
      minWidth: "100px",
    },
    {
      accessor: "agentCommissionIsSettled",
      Header: "تسویه",
      minWidth: "50px",
      Cell: ({ row }) => (
        <>
          {row.original.agentCommissionIsSettled == true ? <span style={{ color: green }}>انجام شده</span> : "درانتظار"}
        </>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      ///                 minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <i
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {}}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-bs-custom-class="tooltip-dark"
            title={showDetail(row.original.details)}
            data-bs-delay-hide="1000"
          >
            <b>i</b>
          </i>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={props.data} />
    </div>
  );
}

export default DataGridUsedPromoCodeByUser;
